import { gql } from '@apollo/client';
import { MediaFragment } from '../fragments/MediaFragment';
/**
 * @const MediasQuery
 * @since 1.0.0
 */
export const MediasQuery = gql `
  query MediasQuery($input: MediasInput) {
    medias(input: $input) {
      ...MediaFragment
    }
  }

  ${MediaFragment}
`;
